
import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from "html5-qrcode";

interface PlansScannerProps {
  isScanning: boolean;
  onScanSuccess: (decodedText: string) => void;
  onClose: () => void;
}

const PlansScanner: React.FC<PlansScannerProps> = ({ isScanning, onScanSuccess, onClose }) => {
  const scannerRef = useRef<Html5Qrcode | null>(null);

  useEffect(() => {
    if (isScanning) {
      const startScanner = async () => {
        try {
          await new Promise(r => setTimeout(r, 100));
          
          const html5QrCode = new Html5Qrcode("reader-plans");
          scannerRef.current = html5QrCode;
          
          await html5QrCode.start(
            { facingMode: "environment" },
            {
              fps: 10,
              qrbox: { width: 250, height: 250 },
              aspectRatio: 1.0
            },
            (decodedText) => {
              onScanSuccess(decodedText);
              html5QrCode.stop().then(() => html5QrCode.clear()).catch(console.error);
            },
            (errorMessage) => {
              // ignore
            }
          );
        } catch (err) {
          console.error("Error starting scanner", err);
          onClose(); // Close on error to prevent stuck state
        }
      };

      startScanner();

      return () => {
        if (scannerRef.current?.isScanning) {
           scannerRef.current.stop().then(() => scannerRef.current?.clear()).catch(console.error);
        }
      };
    }
  }, [isScanning, onScanSuccess, onClose]);

  if (!isScanning) return null;

  return (
    <div className="fixed inset-0 z-[300] bg-black/95 flex flex-col items-center justify-center p-4 animate-in fade-in">
       <div className="w-full max-w-sm rounded-3xl overflow-hidden relative border border-white/20 shadow-2xl bg-black">
          <div id="reader-plans" className="w-full overflow-hidden rounded-2xl"></div>
          
          <div className="absolute top-4 right-4 z-20">
             <button onClick={onClose} className="w-10 h-10 rounded-full bg-black/50 text-white backdrop-blur-md flex items-center justify-center hover:bg-rose-500 transition-colors">
                <i className="fas fa-times"></i>
             </button>
          </div>
          
          <div className="bg-slate-900 p-4 text-center">
             <p className="text-white text-xs font-bold mb-1">Align Code within frame</p>
             <p className="text-slate-400 text-[10px]">Scanning...</p>
          </div>
       </div>
    </div>
  );
};

export default PlansScanner;
